import { getCompanyProfileList } from 'services/axios/config'

const actions = {
  COMPANY_PROFILE_SET_STATE: 'COMPANY_PROFILE_SET_STATE',
  COMPANY_PROFILE_DETAILS: 'COMPANY_PROFILE_DETAILS',
}

export const toggleLoading = (value) => {
  return {
    type: 'TOGGLE_LOADING',
    payload: value,
  }
}

export const fetchCompanyProfile = ({ skip = 0, limit = 10 } = {}) => {
  return async (dispatch) => {
    dispatch(toggleLoading(true))

    const response = await getCompanyProfileList({ skip, limit })

    dispatch({
      type: actions.COMPANY_PROFILE_DETAILS,
      payload: response?.data?.data,
    })

    dispatch(toggleLoading(false))

    return response?.data?.data
  }
}

export default actions
